import UserComponent from "~/components/pages/supervisor/users";

export default function UsersPage() {
  return (
    <div className="z-10">
      <UserComponent />
    </div>
  );
}
